import React from 'react';
import { getSrcSetForLazy } from '../../../../utils/getSrcSetForLazy';
export const ImagePreloadLinks = ({ images, maxSize, sizes }) => {
    return React.createElement(React.Fragment, null, images.map((src, i) => (React.createElement("link", { key: src, rel: "preload", as: "image", imageSrcSet: getSrcSetForLazy(src, maxSize), imageSizes: sizes }))));
};
